'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _proptypes = require('./proptypes');

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

var ButtonWithFeatures = function ButtonWithFeatures(props) {
  var children = props.children,
      type = props.type,
      isLoading = props.isLoading,
      handleSubmit = props.handleSubmit,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'type', 'isLoading', 'handleSubmit']);

  return _react2.default.createElement(
    _style.BeautifulButton,
    (0, _extends3.default)({ type: type || 'text' }, otherProps),
    isLoading && _react2.default.createElement(_style.LoadingSpinner, { width: '24px', height: '24px' }),
    children
  );
};

ButtonWithFeatures.propTypes = _proptypes.propTypes;
ButtonWithFeatures.defaultProps = _proptypes.defaultProps;

ButtonWithFeatures.displayName = 'Button';

exports.default = ButtonWithFeatures;